(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4b-shop-by-colour"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fourb-colour-edit')) {
    customElements.define('fourb-colour-edit', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const activate = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            activate(tabs[next], true);
          });
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[role="tabpanel"]');
          const tab = tabs.find(item => item.getAttribute('aria-controls') === panel?.id);
          if (tab) activate(tab);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
